:host {
  display: block;
  max-width: 100%;
  padding: 64px 0 16px 16px;
  overflow: hidden;
}

gz-accordion {
  &::part(slotContent) {
    padding: 0 0 0 var(--spacer);
  }

  &::part(accordionHeader) {
    color: var(--chart-300-icon-buttons);
    font-weight: 500;
  }
}

.content {
  height: calc(100% - 86px);
  overflow-x: hidden;
  overflow-y: scroll;
  padding-right: calc(var(--spacer) - 2px);
}
